"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * AAS Indexer API
 * The API implemented by the AAS indexer
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardsApi = exports.DashboardsApiFactory = exports.DashboardsApiFp = exports.DashboardsApiAxiosParamCreator = void 0;
const axios_1 = __importDefault(require("axios"));
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DashboardsApi - axios parameter creator
 * @export
 */
const DashboardsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Dashboard} [dashboard]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDashboard: async (dashboard, options = {}) => {
            const localVarPath = `/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(dashboard, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {Graph} [graph]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGrafanaPanel: async (graph, options = {}) => {
            const localVarPath = `/dashboards/panel/graph/generate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(graph, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve all stored dashboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDashboards: async (options = {}) => {
            const localVarPath = `/dashboards`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieve a specify dashboard using its id
         * @param {string} id The id of the dashboard to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('getDashboardById', 'id', id);
            const localVarPath = `/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Remove the dashboard with the given id
         * @param {string} id The id of the dashboard to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDashboardById: async (id, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('removeDashboardById', 'id', id);
            const localVarPath = `/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Replace the dashboard with the given id with the provided specification
         * @param {string} id The id of the dashboard to retrieve
         * @param {Dashboard} [dashboard]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard: async (id, dashboard, options = {}) => {
            // verify required parameter 'id' is not null or undefined
            common_1.assertParamExists('updateDashboard', 'id', id);
            const localVarPath = `/dashboards/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(dashboard, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DashboardsApiAxiosParamCreator = DashboardsApiAxiosParamCreator;
/**
 * DashboardsApi - functional programming interface
 * @export
 */
const DashboardsApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DashboardsApiAxiosParamCreator(configuration);
    return {
        /**
         *
         * @param {Dashboard} [dashboard]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addDashboard(dashboard, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addDashboard(dashboard, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         *
         * @param {Graph} [graph]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async generateGrafanaPanel(graph, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.generateGrafanaPanel(graph, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve all stored dashboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllDashboards(options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllDashboards(options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Retrieve a specify dashboard using its id
         * @param {string} id The id of the dashboard to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDashboardById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDashboardById(id, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Remove the dashboard with the given id
         * @param {string} id The id of the dashboard to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async removeDashboardById(id, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.removeDashboardById(id, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
        /**
         * Replace the dashboard with the given id with the provided specification
         * @param {string} id The id of the dashboard to retrieve
         * @param {Dashboard} [dashboard]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateDashboard(id, dashboard, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateDashboard(id, dashboard, options);
            return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
        },
    };
};
exports.DashboardsApiFp = DashboardsApiFp;
/**
 * DashboardsApi - factory interface
 * @export
 */
const DashboardsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DashboardsApiFp(configuration);
    return {
        /**
         *
         * @param {Dashboard} [dashboard]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addDashboard(dashboard, options) {
            return localVarFp.addDashboard(dashboard, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Graph} [graph]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        generateGrafanaPanel(graph, options) {
            return localVarFp.generateGrafanaPanel(graph, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve all stored dashboards
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllDashboards(options) {
            return localVarFp.getAllDashboards(options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieve a specify dashboard using its id
         * @param {string} id The id of the dashboard to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDashboardById(id, options) {
            return localVarFp.getDashboardById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Remove the dashboard with the given id
         * @param {string} id The id of the dashboard to retrieve
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeDashboardById(id, options) {
            return localVarFp.removeDashboardById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Replace the dashboard with the given id with the provided specification
         * @param {string} id The id of the dashboard to retrieve
         * @param {Dashboard} [dashboard]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateDashboard(id, dashboard, options) {
            return localVarFp.updateDashboard(id, dashboard, options).then((request) => request(axios, basePath));
        },
    };
};
exports.DashboardsApiFactory = DashboardsApiFactory;
/**
 * DashboardsApi - object-oriented interface
 * @export
 * @class DashboardsApi
 * @extends {BaseAPI}
 */
class DashboardsApi extends base_1.BaseAPI {
    /**
     *
     * @param {Dashboard} [dashboard]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    addDashboard(dashboard, options) {
        return exports.DashboardsApiFp(this.configuration).addDashboard(dashboard, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Graph} [graph]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    generateGrafanaPanel(graph, options) {
        return exports.DashboardsApiFp(this.configuration).generateGrafanaPanel(graph, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve all stored dashboards
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    getAllDashboards(options) {
        return exports.DashboardsApiFp(this.configuration).getAllDashboards(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Retrieve a specify dashboard using its id
     * @param {string} id The id of the dashboard to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    getDashboardById(id, options) {
        return exports.DashboardsApiFp(this.configuration).getDashboardById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Remove the dashboard with the given id
     * @param {string} id The id of the dashboard to retrieve
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    removeDashboardById(id, options) {
        return exports.DashboardsApiFp(this.configuration).removeDashboardById(id, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Replace the dashboard with the given id with the provided specification
     * @param {string} id The id of the dashboard to retrieve
     * @param {Dashboard} [dashboard]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DashboardsApi
     */
    updateDashboard(id, dashboard, options) {
        return exports.DashboardsApiFp(this.configuration).updateDashboard(id, dashboard, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DashboardsApi = DashboardsApi;
//# sourceMappingURL=dashboards-api.js.map